
















import { CustomFieldCreateDtoHelper } from "@/store/modules/custom-field.store";
import { Component, Prop } from "vue-property-decorator";
import CustomFieldText from "./CustomFieldText.vue";

@Component({
  components: {}
})
export default class CustomFieldNumber extends CustomFieldText {
  @Prop()
  customField!: CustomFieldCreateDtoHelper;
}
